import React from 'react';
import CourseScreen from './screens/Courses';
import ProtectedRoute from '../components/App/ProtectedRoute';
import { Redirect, Switch } from 'react-router-dom';
import Main from './screens/Main';
import SyllabusScreen from './screens/Syllabus';
import StudentsScreen from './screens/Students';
import UsersScreen from './screens/Users';
import AssignmentsScreen from './screens/Syllabus/screens/Assignments';
import CanvasScreen from './screens/integrations/screens/lms/canvas';
import SuccessIntegrationScreen from './screens/integrations/screens/lms/success';
import ErrorIntegrationScreen from './screens/integrations/screens/lms/error';
import ScheduleSystemScreen from './screens/integrations/screens/ss/main';
import { useSelector } from "react-redux";
import PermissionsScreen from './screens/permissions';
import UserSelectionScreen from './screens/Courses/screens/user-selection';

function DashboardRoutes(props) {
  const { data } = useSelector( state => state.user );

  return (
    <React.Fragment> 
        <Switch>
          <ProtectedRoute path="/dashboard/courses" exact component={() => <CourseScreen {...props}/>}/>
          <ProtectedRoute path="/dashboard/courses/:courseId/user-selection" exact component={() => <UserSelectionScreen {...props}/>}/>
          <ProtectedRoute path="/dashboard/syllabus" exact component={() => <SyllabusScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/syllabus/:courseId/lesson/:lessonId/assignments" exact component={() => <AssignmentsScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/students" exact component={() => <StudentsScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/users" exact component={() => <UsersScreen {...props}/>}/>
          <ProtectedRoute path="/dashboard/users/students" exact component={() => <UsersScreen  profile="student" {...props}/>}/>
          <ProtectedRoute path="/dashboard/users/teachers" exact component={() => <UsersScreen  profile="teacher" {...props}/>}/>
          <ProtectedRoute path="/dashboard/users/managers" exact component={() => <UsersScreen  profile="manager" {...props}/>}/>
          {/*<ProtectedRoute path="/dashboard/courses-students" exact component={() => <CoursesStudentsScreen  {...props}/>}/>              */}
          <ProtectedRoute path="/dashboard/integrations" exact component={() => <CanvasScreen  {...props}/>}/>              
          <ProtectedRoute path="/dashboard/integrations/lms" exact component={() => <CanvasScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/integrations/ss" exact component={() => <ScheduleSystemScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/integrations/success" exact component={() => <SuccessIntegrationScreen  {...props}/>}/>
          <ProtectedRoute path="/dashboard/integrations/error" exact component={() => <ErrorIntegrationScreen  {...props}/>}/>

          {data && data.profile === 'manager' ?
            <ProtectedRoute path="/dashboard" exact component={() => <Main {...props}/>}/>
            : 
            <ProtectedRoute path="/dashboard" exact component={() => <CourseScreen {...props}/>}/>
          }  
          
          {data && (data.profile === 'manager' || data.profile === 'teacher') && (
            <React.Fragment>              
              <ProtectedRoute path="/dashboard/permissions" exact component={() => <PermissionsScreen  {...props}/>}/>
            </React.Fragment>
          )}

          <Redirect to="/dashboard" />      
        </Switch>
    </React.Fragment>    
  );
}

export default DashboardRoutes;
